export function sortCountriesAlphabetically(countries: any[]) {
  return [...countries].sort((a, b) => a.name.localeCompare(b.name));
}

export function sortCurrenciesAlphabetically(currencies?: any[]) {
  if (!Array.isArray(currencies)) return [];

  return [...currencies].sort((a, b) => a.name.localeCompare(b.name));
}

export function getSortedIndustryNames(industries?: any[]) {
  if (!Array.isArray(industries)) return [];

  return [...industries].sort((a, b) => a.name.localeCompare(b.name));
}

export function sortedByName(sortArray?: any[]) {
  if (!Array.isArray(sortArray)) return [];
  return [...sortArray].sort((a, b) => a.name.localeCompare(b.name));
}
